import { render } from "./ReviewRequestView.vue?vue&type=template&id=070a35c1"
import script from "./ReviewRequestView.vue?vue&type=script&lang=js"
export * from "./ReviewRequestView.vue?vue&type=script&lang=js"

import "./ReviewRequestView.vue?vue&type=style&index=0&id=070a35c1&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__